import { useCallback, useMemo, useState } from "react";
import { useTheme } from "@/providers/ThemeProvider";
import useAuth from "@/hooks/useAuth";
import { formatUsdCompact } from "@/lib/format";
import { BalanceService } from "@/services/Balance";
import { CardService } from "@/services/Card";
import { TopNavbarComponent } from "./TopNavbarComponent";

const languages = [
	{ code: "EN", label: "English" },
	{ code: "RU", label: "Russian" },
];

export const TopNavbar = () => {
	const [lang, setLang] = useState("EN");
	const { resolvedTheme, setTheme, canToggle } = useTheme();
	const isDark = resolvedTheme === "dark";
	const [depositOpen, setDepositOpen] = useState(false);
	const { logout } = useAuth();

	const { data: balanceData } = BalanceService.useGetBalanceQuery();
	const { data: cardsData } = CardService.useGetCardsQuery();

	const usdBalance = balanceData?.available ?? 0;

	const cardsBalance = useMemo(
		() => (cardsData ?? []).reduce((sum, c) => sum + c.balance, 0),
		[cardsData],
	);

	const handleToggleTheme = useCallback(
		() => setTheme(isDark ? "light" : "dark"),
		[isDark, setTheme],
	);

	return (
		<TopNavbarComponent
			lang={lang}
			onLangChange={setLang}
			languages={languages}
			isDark={isDark}
			onToggleTheme={handleToggleTheme}
			canToggleTheme={canToggle}
			depositOpen={depositOpen}
			onDepositOpenChange={setDepositOpen}
			onLogout={logout}
			mockUsdBalance={usdBalance}
			cardsBalanceFormatted={formatUsdCompact(cardsBalance)}
			usdBalanceFormatted={formatUsdCompact(usdBalance)}
		/>
	);
};
